import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useMaintenanceFinancialReviewSimpleEntriesReject } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/financialReview/simpleEntries/useMaintenanceFinancialReviewSimpleEntriesReject'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const FinancialReviewEntrySimpleEntryReject = () => {
  const { workflow, forwarding } = useForwardingTabContext()

  const { id } = useParams()

  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: reject, isPending: rejectIsPending } = useMaintenanceFinancialReviewSimpleEntriesReject({
    financialReviewEntryId: workflow?.current_forwarding?.financial_review_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        })

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        })
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error)
      },
    },
  })

  return (
    <>
      <Button
        variant="yellow"
        operationKlassToCheckPermission="Client::Maintenance::FinancialReview::SimpleEntries::Reject"
        onClick={() => reject()}
        isLoading={rejectIsPending}
      >
        Declinar
      </Button>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default FinancialReviewEntrySimpleEntryReject
